import React from 'react';


//  {{...(this.props.style || {}), ...polygonStyle}}

export default class CornerCover extends React.Component {

    static defaultProps = {
        style: {}
    };

    render() {
        return (
            <svg viewBox="0 0 200 200" className={'corner-cover no-print'} style={this.props.style}>
                <polygon
                    points="200,80 200,200 80,200" style={{fill: '#000', strokeWidth: 0, opacity: .1, ...this.props.style}}
                />
                <polygon
                    points="200,40 200,60 60,200 40,200" style={{fill: '#000', strokeWidth: 0, opacity: .1, ...this.props.style}}
                />
            </svg>
        )
    }

}
